import { MOKA_SERVICE_HOST } from 'api/constants';

export const CAPITAL_CONSENT_URL = `${MOKA_SERVICE_HOST}/capital/v1/consents`;
export const GET_DASHBOARD_CAPITAL = `${MOKA_SERVICE_HOST}/capital/v1/submissions`;
export const CAPITAL_PREAPPROVALS_URL = `${MOKA_SERVICE_HOST}/capital/v1/preapprovals`;
export const PUT_SIGIN_CONTRACT_CLICK = documentId =>
  `${MOKA_SERVICE_HOST}/capital/v1/documents/${documentId}/views`;
export const FINAL_APPROVALS = `${MOKA_SERVICE_HOST}/capital/v1/finalapprovals`;
export const ELIGIBLE_CHECK = `${MOKA_SERVICE_HOST}/capital/v1/loan-eligibilities`;
export const COMMONWEALTH_PROVINCES = `${MOKA_SERVICE_HOST}/capital/v1/commonwealth/provinces`;
export const COMMONWEALTH_CITIES = `${MOKA_SERVICE_HOST}/capital/v1/commonwealth/cities`;
